const CHARS = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'

export function randomCaptchaCode(length = 4) {
  let out = ''
  for (let i = 0; i < length; i += 1) {
    out += CHARS[Math.floor(Math.random() * CHARS.length)]
  }
  return out
}

export function drawCaptchaDataUrl(code, options = {}) {
  const width = options.width || 110
  const height = options.height || 36
  const canvas = document.createElement('canvas')
  canvas.width = width
  canvas.height = height
  const ctx = canvas.getContext('2d')

  ctx.fillStyle = '#ffffff'
  ctx.fillRect(0, 0, width, height)

  // noise lines
  for (let i = 0; i < 4; i += 1) {
    ctx.strokeStyle = `rgba(${Math.floor(Math.random() * 120)}, ${Math.floor(
      Math.random() * 120
    )}, ${Math.floor(Math.random() * 120)}, 0.35)`
    ctx.beginPath()
    ctx.moveTo(Math.random() * width, Math.random() * height)
    ctx.lineTo(Math.random() * width, Math.random() * height)
    ctx.stroke()
  }

  // dots
  for (let i = 0; i < 26; i += 1) {
    ctx.fillStyle = `rgba(${Math.floor(Math.random() * 140)}, ${Math.floor(
      Math.random() * 140
    )}, ${Math.floor(Math.random() * 140)}, 0.25)`
    ctx.beginPath()
    ctx.arc(Math.random() * width, Math.random() * height, 1 + Math.random() * 1.2, 0, Math.PI * 2)
    ctx.fill()
  }

  // text
  ctx.textBaseline = 'middle'
  ctx.font = 'bold 18px Arial'
  const padX = 10
  const gap = (width - padX * 2) / Math.max(code.length, 1)
  for (let i = 0; i < code.length; i += 1) {
    const ch = code[i]
    ctx.save()
    const x = padX + gap * i + gap / 2
    const y = height / 2
    ctx.translate(x, y)
    ctx.rotate((Math.random() - 0.5) * 0.45)
    ctx.fillStyle = `rgb(${40 + Math.floor(Math.random() * 120)}, ${40 + Math.floor(
      Math.random() * 120
    )}, ${40 + Math.floor(Math.random() * 120)})`
    ctx.fillText(ch, -6, 0)
    ctx.restore()
  }

  return canvas.toDataURL('image/png')
}

